import boopSfx from '../mp3/card.mp3';
import leaveSfx from '../mp3/leave.mp3';

class SoundManager {
  constructor() {
    this.lastPlayedMessageId = null;
  }

  async playSound(soundType, messageUid = null) {
    try {
      if (soundType === 'new') {
        if (messageUid && messageUid !== this.lastPlayedMessageId) {
          const audio = new Audio(boopSfx);
          await audio.play();
          this.lastPlayedMessageId = messageUid;
        }
      } else if (soundType === 'leave') {
        const audio = new Audio(leaveSfx);
        await audio.play();
      }
    } catch (error) {
      console.error(`Erro ao reproduzir som '${soundType}':`, error);
    }
  }
}

export const soundManager = new SoundManager();
